import React, { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import PlayerSeasonCharts from "../components/PlayerSeasonCharts";

// Standalone, no-nav-chrome page rendered by a real headless browser
// (Puppeteer, server side) to generate the Export PDF button's file --
// deliberately NOT the interactive modal, and NOT a screenshot/print of it.
// Loading a fresh, dedicated page gives Recharts a normal, one-shot mount
// with no prior on-screen layout to reconcile against, which is exactly
// what a screenshot-of-the-live-modal and window.print() of the live modal
// both got wrong (both fights over stale ResizeObserver-computed SVG sizing
// from a totally different on-screen layout).
//
// Auth: this page is opened with nobody logged in (a fresh Puppeteer
// browser context has no session), so it takes a short-lived, single-purpose
// token in the query string (minted by POST /api/stats/player/:name/export-pdf
// for exactly this render) rather than using the shared `api` instance,
// which only knows how to read the real user's session token from storage.
export default function PrintPlayerStats() {
  const { name } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios.get(`/api/stats/player/${encodeURIComponent(name)}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => setRows(res.data))
      .catch(() => setError(true));
  }, [name, token]);

  if (error) {
    return <div data-export-ready="true" style={{ padding: 20, fontFamily: "sans-serif" }}>Failed to load stats.</div>;
  }
  if (rows === null) {
    return <div style={{ padding: 20, fontFamily: "sans-serif" }}>Loading…</div>;
  }
  return (
    <div data-export-ready="true" style={{ padding: 20, fontFamily: "sans-serif" }}>
      <PlayerSeasonCharts playerName={name} rows={rows} />
    </div>
  );
}
